'use client';

import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../estilos/StyNav.css";
import logo from "../img-etc/logo.png";
import { useTranslation } from 'react-i18next';

function Navega() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const indicatorRef = useRef(null);
  const menuRef = useRef(null);
  const linksRef = useRef([]);
  const isFirstRender = useRef(true);
  const { t, i18n } = useTranslation(); 

  const menu = [ 
    { label: t('nav_home'), path: "/" },
    { label: t('nav_quienes'), path: "/Quienes_somos" },
    { label: t('nav_contacto'), path: "/contacto" },
    { label: t('nav_experiencias'), path: "/AllExperiencia" },
    { label: t('nav_reseñas'), path: "/reseñas" }
  ];

  const cambiarIdioma = () => {
    i18n.changeLanguage(i18n.language === 'es' ? 'en' : 'es');
  };

  useEffect(() => {
    const index = menu.findIndex((m) => m.path === location.pathname);
    const link = linksRef.current[index];
    const menuEl = menuRef.current;

    if (link && indicatorRef.current && menuEl) {
      const linkRect = link.getBoundingClientRect();
      const menuRect = menuEl.getBoundingClientRect();
      const offsetLeft = linkRect.left - menuRect.left;
      
      if (isFirstRender.current) {
        indicatorRef.current.style.transition = 'none';
      }
      
      indicatorRef.current.style.width = `${linkRect.width}px`;
      indicatorRef.current.style.transform = `translateX(${offsetLeft}px)`;
      
      if (isFirstRender.current) {
        requestAnimationFrame(() => {
          if (indicatorRef.current) {
            indicatorRef.current.style.transition = '';
          }
          isFirstRender.current = false;
        });
      }
    }
  }, [location.pathname, i18n.language]);

  return (
    <header className="nav">
      <div className="nav-container">
        <div className="nav-logo" onClick={() => navigate("/")}>
          <img src={logo || "/placeholder.svg"} alt="Pacific Tour CR" />
        </div>

        <nav ref={menuRef} className={`nav-menu ${open ? "open" : ""}`}>
          {menu.map((item, i) => (
            <button
              key={item.label}
              ref={(el) => (linksRef.current[i] = el)}
              className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
              onClick={() => {
                navigate(item.path);
                setOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
          <span ref={indicatorRef} className="nav-indicator" />
        </nav>

        {/* BOTÓN IDIOMA */}
        <button className="btn-idioma" onClick={cambiarIdioma}>
          {i18n.language === 'es' ? '🇺🇸 EN' : '🇨🇷 ES'}
        </button>

        <button
          className={`nav-toggle ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {open && (
        <div className="nav-mobile">
          {menu.map((item) => (
            <button
              key={item.label}
              className={`nav-mobile-link ${location.pathname === item.path ? "active" : ""}`}
              onClick={() => {
                navigate(item.path);
                setOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}

export default Navega;